import { OneTrustApiValidationError } from './validation';
/**
 * @example
 * ",C0001,C0002" => ["C0001", "C0002"]
 */
const normalizeActiveGroupIds = (oneTrustActiveGroups) => {
    return oneTrustActiveGroups.trim().split(',').filter(Boolean);
};
export var OtConsentModel;
(function (OtConsentModel) {
    OtConsentModel["optIn"] = "opt-in";
    OtConsentModel["optOut"] = "opt-out";
    OtConsentModel["implicit"] = "implied consent";
})(OtConsentModel || (OtConsentModel = {}));
export const getOneTrustGlobal = () => {
    // window.OneTrust = {...} is used for user configuration e.g. 'Consent Rate Optimization'
    // Also, if "show banner" is unchecked, window.OneTrust returns {geolocationResponse: {…}} before it actually returns the OneTrust object
    // Thus, we are doing duck typing to see when this object is 'ready'
    // function OptAnonWrapper()  is the idiomatic way to check if OneTrust is ready, but polling for this works
    const oneTrust = window.OneTrust;
    if (!oneTrust)
        return undefined;
    if (typeof oneTrust === 'object' &&
        'OnConsentChanged' in oneTrust &&
        'IsAlertBoxClosed' in oneTrust &&
        'GetDomainData' in oneTrust) {
        return oneTrust;
    }
};
export const getOneTrustActiveGroups = () => {
    const groups = window.OnetrustActiveGroups;
    if (!groups)
        return undefined;
    if (typeof groups !== 'string') {
        throw new OneTrustApiValidationError(`window.OnetrustActiveGroups is not a string`, groups);
    }
    return groups;
};
export const getNormalizedActiveGroupIds = (oneTrustActiveGroups = getOneTrustActiveGroups()) => {
    if (!oneTrustActiveGroups) {
        return [];
    }
    return normalizeActiveGroupIds(oneTrustActiveGroups || '');
};
const normalizeGroupInfo = (groupInfo) => ({
    groupId: groupInfo.CustomGroupId.trim(),
});
/**
 * get *all* groups / categories, not just active ones
 */
export const getAllGroups = () => {
    const oneTrustGlobal = getOneTrustGlobal();
    if (!oneTrustGlobal)
        return [];
    return oneTrustGlobal.GetDomainData().Groups.map(normalizeGroupInfo);
};
export const getNormalizedCategories = (activeGroupIds = getNormalizedActiveGroupIds()) => {
    return getAllGroups().reduce((acc, group) => {
        return {
            ...acc,
            [group.groupId]: activeGroupIds.includes(group.groupId),
        };
    }, {});
};
/**
 *  We don't support all consent models, so we need to coerce them to the ones we do support.
 */
export const coerceConsentModel = (model) => {
    switch (model) {
        case OtConsentModel.optIn:
        case OtConsentModel.implicit:
            return 'opt-in';
        case OtConsentModel.optOut:
            return 'opt-out';
        default: // there are some others like 'custom' / 'notice' that should be treated as 'opt-out'
            return 'opt-out';
    }
};
//# sourceMappingURL=onetrust-api.js.map